import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row justify-between gap-12 mb-12">
            <div className="lg:max-w-xs">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-xs tracking-[0.2em] uppercase text-background-300 font-label font-medium">
                  Itaobuy
                </span>
                <span className="text-xs tracking-[0.15em] uppercase text-background-400 font-label font-light">
                  Spreadsheet
                </span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed font-body">
                La tua guida italiana indipendente su Itaobuy Spreadsheet. Recensioni, tutorial, confronti e consigli pratici per utilizzare al meglio itaobuy sheet.
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
              <div>
                <h4 className="text-sm font-semibold text-background-200 mb-4 font-heading">Navigazione</h4>
                <ul className="space-y-2.5">
                  <li>
                    <a href="/" className="text-sm text-background-400 hover:text-background-200 transition-colors font-body">
                      Home
                    </a>
                  </li>
                  <li>
                    <a href="/articolo/itaobuy-sheet-guida-completa" className="text-sm text-background-400 hover:text-background-200 transition-colors font-body">
                      Guida Completa
                    </a>
                  </li>
                  <li>
                    <a href="#faq" className="text-sm text-background-400 hover:text-background-200 transition-colors font-body">
                      FAQ
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-200 mb-4 font-heading">Link Utili</h4>
                <ul className="space-y-2.5">
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-400 hover:text-background-200 transition-colors font-body"
                    >
                      Sito Ufficiale
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-400 hover:text-background-200 transition-colors font-body"
                    >
                      Itaobuy Sheet
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-400 hover:text-background-200 transition-colors font-body"
                    >
                      Acquista Ora
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-200 mb-4 font-heading">Categorie</h4>
                <ul className="space-y-2.5">
                  <li>
                    <a
                      href="https://kaspreadsheet.com/category-911-Shoes.html"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-400 hover:text-background-200 transition-colors font-body"
                    >
                      Shoes
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com/search-913/name/Shoes.html"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-400 hover:text-background-200 transition-colors font-body"
                    >
                      T-Shirts
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com/search-912/name/Shoes.html"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-400 hover:text-background-200 transition-colors font-body"
                    >
                      Hoodies
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700/30 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500 font-body">
              &copy; {new Date().getFullYear()} Itaobuy Spreadsheet Italia. Tutti i diritti riservati.
            </p>
            <p className="text-xs text-background-500 font-body">
              Questo sito è una guida informativa indipendente. Non siamo affiliati ufficialmente.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}